import { render } from "./DictionaryItemCard.vue?vue&type=template&id=7f71be61"
import script from "./DictionaryItemCard.vue?vue&type=script&lang=js"
export * from "./DictionaryItemCard.vue?vue&type=script&lang=js"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__